import classes from './ToggleIndicator.module.css';

const ToggleIndicator = (props) => (
    <div className={`${classes.toggle} ${props.dark ? classes.dark : ''} ${props.disabled ? classes.disabled : ''}`}>
        <svg
            className={`${props.toggled && classes.toggled}`}
            width="6"
            height="3"
            viewBox="0 0 6 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M0 0L3 3L6 0L0 0Z" />
        </svg>
    </div>
);

export default ToggleIndicator;
